import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * Generates the property to pass to `store.updateEvents()` to create an event extracted from a potentially recurring event.
 */
export function createEventFromRecurringEvent(originalEvent, changes) {
  const createdEvent = _extends({}, originalEvent.modelInBuiltInFormat, changes, {
    extractedFromId: originalEvent.id
  });

  // @ts-ignore
  delete createdEvent.id;
  delete createdEvent.rrule;
  delete createdEvent.exDates;
  return createdEvent;
}